export default function($) {
  if ( ! window.__tabsResponsiveInit ) {
    window.__tabsResponsiveInit = true;
    var mq = window.matchMedia( '(min-width: 1024px)' );
    function syncTabsOpen( e ) {
      if ( e.matches ) {
        $( '.tab-item' ).attr( 'open', '' );
      } else {
        $( '.tab-item' ).removeAttr( 'open' );
      }
    }
    mq.addEventListener( 'change', syncTabsOpen );
    syncTabsOpen( mq );
  }
}
